import { media } from "src/layouts/utils";
import styled from "styled-components";

export const InnerContainer = styled.div`
  max-width: 1444px;
  width: 100%;

  ${media.phone`
    max-width: 100%;
    overflow-x: ${(props) => (props.noOverflow ? "unset" : "hidden")};
    overflow-y: ${(props) => (props.noOverflow ? "unset" : "hidden")};
		padding-inline: 0;
    `}
`;

export const ContainerListButton = styled.div`
  display: flex;
  width: 100%;
  gap: 80px;

  ${media.phone`
    padding-bottom: 0;
  `}
`;

export const Image = styled.img`
	max-height: 3rem;
`;

export const ContentImage = styled.div`
  height: 75%;
  display: flex;
  align-items: center;
  ${media.desktop`
    display: none;
  `}
`;
